import { useState } from "react";
import { useAddEmailMutation, useDeleteUnionEmailMutation, useGetAllUnionsQuery } from "../../redux/api/union";
import { toast } from "react-toastify";
import { unionEmailCreateParams, Union } from "../../common/Union";
import { Delete } from "@mui/icons-material";
import { Button, TableContainer, Table, TableHead, TableRow, TableCell, TableBody, Dialog, Typography, TextField, Select, MenuItem } from "@mui/material";
import { NavLink } from "react-router-dom";


const UnionHall = () => {

    const [confirmDeleteUnion, setConfirmDeleteUnion] = useState(false);
    const [addUnion, setAddUnion] = useState(false);
    const [selectedUnion, setSelectedUnion] = useState<string | null>(null);
    const [unionEmail, setUnionEmail] = useState('');
    const [currUnionId, setCurrUnionId] = useState<number>();
    const {
        data: unionHalls,
        isLoading: isLoadingUnions,
        isFetching: isFetchingUnions,
        refetch: refetchUnions,
    } = useGetAllUnionsQuery();
    const [addEmail] = useAddEmailMutation();
    const [deleteUnionEmail] = useDeleteUnionEmailMutation();

    const handleDeleteUnionClose = () => {
        setConfirmDeleteUnion(false);
    }

    const handleDeleteUnionOpen = (unionId: number, name: string, email: string) => {
        setCurrUnionId(unionId);
        setSelectedUnion(name);
        setUnionEmail(email);
        setConfirmDeleteUnion(true);
    };

    const handleAddUnionClose = () => {
        setAddUnion(false);
        setSelectedUnion(null);
    }
    const handleAddUnionOpen = () => {
        setSelectedUnion('');
        setUnionEmail('');
        setAddUnion(true);
    }

    const handleAddUnionEmail = async () => {
        const unionCreateParams: unionEmailCreateParams = {
            email: unionEmail,
            id: currUnionId!,
        };
        addEmail(unionCreateParams).then((response) => {
            if (!("error" in response)) {
                refetchUnions();
                setAddUnion(false);
                toast.success(<p>Union Hall Email created successfully</p>);
            }
        });
    }

    const handleDeleteUnion = async () => {
        const response = await deleteUnionEmail({ unionId: currUnionId!.toString(), email: unionEmail } )
        if (!("error" in response)) {
            refetchUnions();
            setConfirmDeleteUnion(false);
            toast.success(<p>Union Hall Email deleted successfully</p>)
        }
    }

    const transformUnionEmails = (unions: Union[]) => {
        let output: { id: number, name: string, email: string }[] = [];
        unions = unions.filter(union => !!union.emails && union.emails.length > 0)
        unions.forEach(union => {
            union.emails!.forEach(email => {
                output.push({ id: union.id, name: union.name, email: email })
            })
        })
        return output;
    }

    return (
        <>
            <div className="flex align-items-center g-3" style={{ marginTop: '60px' }}>
                <h2>Union Hall</h2>
                <Button
                    variant="contained"
                    className="blue-button"
                    type="submit"
                    onClick={handleAddUnionOpen}
                >
                    Add New
                </Button>
            </div>
            <TableContainer className="flex wd-50">
                <Table className="table ">
                    <TableHead>
                        <TableRow>
                            <TableCell className="wd-240px">
                                Name
                            </TableCell>
                            <TableCell className="wd-240px">
                                Email
                            </TableCell>
                            <TableCell className="wd-100px">
                            </TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {!isLoadingUnions && !isFetchingUnions && !!unionHalls &&
                            transformUnionEmails(unionHalls).map((row) =>
                            (
                                <TableRow key={row.name + ',' + row.email}>
                                    <TableCell>
                                        {row.name}
                                    </TableCell>
                                    <TableCell>
                                        {row.email}
                                    </TableCell>
                                    <TableCell>
                                        <div className="flex justify-content-center align-items-center g-3">
                                            <div className="flex justify-content-left">
                                                <NavLink
                                                    to=""
                                                    className="blue-link"
                                                    onClick={() => handleDeleteUnionOpen(row.id, row.name, row.email)}
                                                >
                                                    <Delete color="primary" />
                                                </NavLink>
                                            </div>
                                        </div>
                                    </TableCell>
                                </TableRow>
                            )
                            )}

                    </TableBody>
                </Table>
            </TableContainer>
            <Dialog
                open={confirmDeleteUnion}
                onClose={handleDeleteUnionClose}
                aria-labelledby="modal-title"
            >
                <Typography component="h2" id="modal-title">
                    Delete Union Hall Email
                </Typography>
                <p>Are you sure you would like to delete the email {unionEmail} for {selectedUnion} Union Hall?</p>
                <div className="modal-footer">
                    <Button
                        className="blue-button-small"
                        onClick={handleDeleteUnion}
                    >
                        Confirm
                    </Button>
                    <Button
                        className="outline-button-small"
                        onClick={handleDeleteUnionClose}
                    >
                        Cancel
                    </Button>
                </div>
            </Dialog>
            <Dialog
                open={addUnion}
                onClose={handleAddUnionClose}
                aria-labelledby="modal-title"
            >
                <TableContainer className="flex wd-50">
                    <Table className="table">
                        <TableHead>
                            <TableRow>
                                <TableCell>
                                    Union Hall
                                </TableCell>
                                <TableCell>
                                    Email
                                </TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            <TableRow>
                                <TableCell>
                                    <Select
                                        name="union"
                                        className="wd-240px"
                                        id="union"
                                        value={selectedUnion}
                                        onChange={(selectedOption) => {
                                            setSelectedUnion(selectedOption.target.value)
                                            setCurrUnionId(+selectedOption.target.value!);
                                        }}
                                    >
                                        {unionHalls && !isFetchingUnions && !isLoadingUnions &&
                                            Object.values(unionHalls).map((union) => (
                                                <MenuItem key={union.id} value={union.id}>
                                                    {union.name}
                                                </MenuItem>
                                            ))}

                                    </Select>
                                </TableCell>
                                <TableCell>
                                    <TextField
                                        name="email"
                                        className="wd-240px"
                                        value={unionEmail}
                                        onChange={(e) => {
                                            setUnionEmail(e.target.value);
                                        }}
                                    />
                                </TableCell>
                            </TableRow>
                        </TableBody>
                    </Table>
                </TableContainer>
                <div className="modal-footer">
                    <Button
                        variant="contained"
                        className="blue-button"
                        type="submit"
                        onClick={handleAddUnionEmail}
                    >
                        Save
                    </Button>
                </div>
            </Dialog>
        </>
    )
}

export default UnionHall;